<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name(v-if="keyName") {{ keyName }}
      slot(name="keyName")
      span.validation-label(v-if="required == true") 必須
      span.option-text.font-strong-color {{ optionText }}
      slot(name="question")

    .register-value(:style="styles")
      input.register-form(
        v-model="_postalCode1"
        :name="name + '-code1'"
        v-validate="validationRules"
        :maxlength="3"
        :data-vv-as="(validationKeyName) ? validationKeyName + '１' : keyName + '１'"
        :class="[ { noinput: (required == true && !_postalCode1) } ]"
        style="width:60px;")
      span.mr-2.ml-2 －
      input.register-form(
        v-model="_postalCode2"
        :name="name + '-code2'"
        v-validate="validationRules"
        :maxlength="4"
        :data-vv-as="(validationKeyName) ? validationKeyName + '２' : keyName + '２'"
        :class="[ { noinput: (required == true && !_postalCode2) } ]"
        style="width:70px;")

    .error-messages(v-for="error in errors.collect(name + '-code1')")
      label.error-message {{ error }}
      br
    .error-messages(v-for="error in errors.collect(name + '-code2')")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * 入力要素コンポーネント
 *
 * - 単一の入力をサポートする
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputPostalCode extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop()
  postalCode1!: string;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop()
  postalCode2!: string;

  /** 項目名 */
  @Prop({ type: String })
  keyName!: string;

  /** 必須か */
  @Prop({
    default: () => {
      return false;
    },
    type: Boolean
  })
  required!: boolean;

  /** name属性の値 */
  @Prop({ required: true, type: String })
  name!: string;

  /** veevalidateに渡すバリデーションルール */
  @Prop()
  validationRules!: string;

  /** veevalidateに渡すバリデーション項目名 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  validationKeyName!: string;

  /** スタイル(主にサイズ指定) */
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  styles!: any;

  /** 説明文 */
  @Prop({
    default: () => {
      return "";
    },
    type: String
  })
  optionText!: string;

  get _postalCode1(): string {
    return this.postalCode1;
  }
  set _postalCode1(newValue: string) {
    this.$emit("update:postalCode1", newValue);
    return;
  }

  get _postalCode2(): string {
    return this.postalCode2;
  }
  set _postalCode2(newValue: string) {
    this.$emit("update:postalCode2", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.register-form {
  max-width: 600px;
  width: 600px;
}
.option-text {
  margin-left: 8px;
}
</style>
